import React, { useContext } from "react";
import NewsContext from "../../context/News/NewsContext";
import styles from "../../styles/News/NewsTab.module.css";

const NewsTab = ({ name,Open }) => {
  const { setFilterType, filterType,topics } = useContext(NewsContext);

  // const randomIntFromInterval = (min, max) => {
  //   // min and max included
  //   return Math.floor(Math.random() * (max - min + 1) + min);
  // };

  // const gradients = [
  //   "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
  //   "ckground: linear-gradient(to right, #12c2e9, #c471ed, #f64f59)",
  //   "linear-gradient(to right, #373b44, #4286f4)",
  //   "linear-gradient(to right, #2980b9, rgb(109, 225, 255)))",
  //   " linear-gradient(to right, #ff0099, #493240)",
  // ];
  return (
    <>
      <div
        className={filterType === name ? styles.activeNewsTab :(name==="Topics"&&topics?.includes(filterType))?styles.activeNewsTab : styles.NewsTab}
        style={{
          cursor: "pointer",
          background:
            filterType === name
              ? name === "Positive"
                ? "rgb(69, 170, 67)"
                : name === "Negative"
                ? "rgb(233, 56, 72)"
                : name === "Neutral"
                ? "#000"
                : name === "Events"
                ? "rgb(51, 153, 255)"
                : name === "All"
                ? "#56cc9d"
                : name==="Topics"?"#56cc9d":null
              :(name==="Topics"&&topics?.includes(filterType))?"#56cc9d": "#EFF2F5",
          whiteSpace: "nowrap",
        }}
        onClick={() => {
          setFilterType(name);
        name==="Topics"&&Open()}}
      >
        <p>{name}</p>
      </div>
    </>
  );
};

export default NewsTab;
